import { useQuery } from "@tanstack/react-query"
import { fetchMe } from "@/entities/auth/api/fetch-me.ts"
import { authQueryKeys } from "@/entities/auth/api/query-keys.ts"
import queryClient from "@/shared/config/query-client.ts"

export function useFetchMe() {
  return useQuery({
    queryKey: authQueryKeys.me,
    queryFn: fetchMe,
    placeholderData: previousData => previousData
  })
}

export function prefetchMe() {
  return queryClient.prefetchQuery({
    queryKey: authQueryKeys.me,
    queryFn: fetchMe
  })
}
